import {Directive, HostListener, Input, OnInit, Renderer2, ElementRef} from '@angular/core';
import { SvcServices } from "../services/svc.service";
@Directive({
  selector: '[buttonSpinner]'
})
export class ButtonSpinner implements OnInit{
  constructor(private _renderer: Renderer2, private _el: ElementRef, private _svcService: SvcServices){}
  @Input('hasValidation') hasValidation: boolean;
  @Input('fDetail') formDetail: any;
  @Input('customValidation') customValidation: boolean;
  @HostListener('click') buttonClick(){
    if(this.hasValidation){
      if(this.formDetail.valid && (this.customValidation == undefined || !this.customValidation)){
        this.createSpinner();
      }
    }else{
      this.createSpinner();
    }

  }
  ngOnInit(){
    this._svcService.endSpinner.subscribe((res)=>{
      if(res) {
        let spinnerDiv = this._el.nativeElement.querySelector('div');
        if(spinnerDiv !== undefined && spinnerDiv != null) {
        this._renderer.removeChild(this._el.nativeElement,spinnerDiv); 
        }
       }
      });
  }
  
  createSpinner() {
    let div = this._renderer.createElement('div');
    this._renderer.setAttribute(div, 'class', 'spinner-wrapper')
    let span = this._renderer.createElement('span');
    this._renderer.setAttribute(span, 'class', 'spinner');
    this._renderer.appendChild(div, span);
    this._renderer.appendChild(this._el.nativeElement, div);
  }
}